export const spaceWords = (word) => {
  if (typeof word !== "string") {
    return "";
  }
  return word.replace(/([a-z])([A-Z])/g, "$1 $2");
};
